<template>
    <v-card flat
            tile
            color="primary"
            class="mb-3 px-6 pt-4 pb-5">

        <v-container color="primary" pa-0 ma-0>
            <v-row class="ma-0 pa-0 mb-0 pb-0 align-center wallet-summary-balance">
                <v-col class="pa-0 subtitle-1 font-weight-bold">{{ $vuetify.lang.t('$vuetify.widgets.cart.total') }}</v-col>
                <v-col class="pa-0 headline font-weight-bold" cols="auto">
                    {{ total | number }}{{ $vuetify.lang.t('$vuetify.points.short') }}
                </v-col>
            </v-row>
            <v-divider class="my-2"></v-divider>
            <v-row class="ma-0 pa-0 mb-0 pb-0 align-center wallet-summary-pending">
                <v-col class="pa-0 body-1">{{ $vuetify.lang.t('$vuetify.widgets.cart.balance') }}:</v-col>
                <v-col class="pa-0 font-weight-bold" cols="auto" :class="{ 'error--text': user.wallet.balance < total || user.wallet.balance === 0 }">
                    {{ user.wallet.balance | number }}{{ $vuetify.lang.t('$vuetify.points.short') }}
                </v-col>
            </v-row>
            <v-divider class="my-3"></v-divider>
            <v-expand-transition>
                <div v-if="invalidDate"
                     class="subtitle-1">
                    <div class="pb-3" v-html="$vuetify.lang.t('$vuetify.widgets.cart.shop_disabled_by_waiting_period', firstDateForCheckout)"></div>
                </div>
                <div v-else-if="user.wallet.balance < total || user.wallet.balance === 0"
                     class="subtitle-1">
                    <div class="pb-3">
                        {{ $vuetify.lang.t('$vuetify.widgets.cart.not_enough') }}
                    </div>
                </div>
            </v-expand-transition>

            <div v-if="inCartOverview">
                <v-checkbox color="white"
                            value="terms"
                            v-model="checkboxes">
                    <template v-slot:label>
                        <div class="body-1 white--text">
                            <i18n path="$vuetify.widgets.cart.data_terms">
                                <template v-slot:0>
                                    <static-content-dialog slug="terms">
                                        <a class="body-1 white--text" href="#" @click.prevent>{{ $vuetify.lang.t('$vuetify.widgets.cart.link_a') }}</a>
                                    </static-content-dialog>
                                </template>
                                <template v-slot:1>
                                    <static-content-dialog slug="data_protection">
                                        <a class="body-1 white--text" href="#" @click.prevent>{{ $vuetify.lang.t('$vuetify.widgets.cart.link_b') }}</a>
                                    </static-content-dialog>
                                </template>
                            </i18n>
                        </div>
                    </template>
                </v-checkbox>

                <v-checkbox color="white"
                            value="protection"
                            v-model="checkboxes">
                    <template v-slot:label>
                        <div class="body-1 white--text">
                            <i18n path="$vuetify.widgets.cart.data_protection">
                                <template v-slot:0>
                                    <static-content-dialog slug="terms">
                                        <a class="body-1 white--text" href="#" @click.prevent>{{ $vuetify.lang.t('$vuetify.widgets.cart.link_c') }}</a>
                                    </static-content-dialog>
                                </template>
                            </i18n>
                        </div>
                    </template>
                </v-checkbox>

                <v-checkbox color="white"
                            value="tax"
                            v-model="checkboxes">
                    <template v-slot:label>
                        <div class="body-1 white--text">
                            {{ $vuetify.lang.t('$vuetify.widgets.cart.tax_income') }}
                        </div>
                    </template>
                </v-checkbox>
            </div>

          <div v-if="!shopEnabled"
               class="pb-3">
            <v-alert icon="mdi-alert-circle-outline"
                     type="error">
              <p class="body-1 ma-0" v-html="$vuetify.lang.t('$vuetify.widgets.checkout.shop_deactivated')"></p>
            </v-alert>
          </div>

          <div class="body-1 mt-4" v-if="showCheckoutInfo">
            <div  v-html="$vuetify.lang.t(checkoutInfoContent)"></div>
          </div>

          <template v-if="showCheckoutAlert">
            <v-alert icon="mdi-alert-circle-outline"
                     type="error">
              <p class="body-1 ma-0" v-html="$vuetify.lang.t(checkoutAlertContent)"></p>
            </v-alert>
          </template>

            <v-btn v-if="inCartOverview" @click="checkout"
                   color="primary darken-1"
                   :disabled="shopIsDisabledByTerms || invalidProfile || checkoutIsInvalid || !shopEnabled || disabled || checkboxes.length < 3 || isLoading"
                   block
                   elevation="0">
                {{ $vuetify.lang.t('$vuetify.buttons.checkout') }}
            </v-btn>
            <v-btn v-else
                   :to="checkoutUrl"
                   color="primary darken-1"
                   :disabled="checkoutIsInvalid || !shopEnabled || disabled || shopIsDisabledByTerms"
                   block
                   elevation="0">
                {{ $vuetify.lang.t('$vuetify.buttons.continue_order') }}
            </v-btn>

        </v-container>
    </v-card>
</template>
<script>
    // 3rd
    import { mapState } from 'vuex';
    import moment from 'moment';
    import StaticContentDialog from './StaticContentDialog';
    // Utils
    import {
        LOADER_CHECKOUT, ROUTE_CHANGE_DATA,
        ROUTE_CHECKOUT,
    } from '../utils/constants';
    import Cart from '../models/Cart';

    export default {
        name: 'account-overview',
        components: {
            StaticContentDialog,
        },
        data() {
            return {
                checkboxes: [],
            }
        },
        props: {
            shipping: {},
            checkout: {},
            total: {},
            user: {},
            disabled: {
                default: false,
            },
            inCartOverview: {
                default: false,
            },
            hasPhysicalProducts: {
                type: Boolean,
            },
            hasDigitalProducts: {
                type: Boolean,
            },
        },
        computed: {
            ...mapState([
                'shopEnabled',
                'shopUserWaitingPeriod',
                'shopIsDisabledByTerms',
                'showCheckoutInfo',
                'showCheckoutAlert',
                'checkoutInfoContent',
                'checkoutAlertContent',
            ]),
            changeProfileUrl() {
                return { name: ROUTE_CHANGE_DATA };
            },
            isLoading() {
                return this.$wait.is(LOADER_CHECKOUT);
            },
            invalidDate() {
                return moment(new Date()).unix() < moment.unix(this.user.created_at).add(Number(this.shopUserWaitingPeriod), 'months').unix();
            },
            invalidBalance() {
                return this.user.wallet.balance < this.total || this.total === 0;
            },
            invalidProfile() {
                return this.shipping === 'private' && !this.user?.profile?.private_address_country;
            },
            checkoutIsInvalid() {
                return this.invalidDate || this.invalidBalance || Cart.isContainingInvalidProduct();
            },
            firstDateForCheckout() {
                return this.$options.filters.date(moment.unix(this.user.created_at).add(3, 'months'));
            },
            checkoutUrl() {
                return { name: ROUTE_CHECKOUT };
            },
        },
    };
</script>
